import { keycloak } from '@/lib/auth';
import { isInvitationAcceptPathname } from '@/lib/invitation-routes';

export type KeycloakInitMode = 'check-sso' | 'login-required' | 'none';

let keycloakInitPromise: Promise<boolean> | null = null;

export function resetKeycloakInitForTests() {
    keycloakInitPromise = null;
}

export function resolveStartupAuthMode(pathname: string): KeycloakInitMode {
    if (isInvitationAcceptPathname(pathname)) {
        return 'none';
    }

    return 'login-required';
}

export async function ensureKeycloakInit(mode: KeycloakInitMode = 'login-required') {
    if (keycloak.didInitialize) {
        return Boolean(keycloak.authenticated || keycloak.token);
    }

    if (!keycloakInitPromise) {
        keycloakInitPromise = keycloak.init({
            ...(mode === 'none' ? {} : { onLoad: mode }),
            pkceMethod: 'S256',
            checkLoginIframe: false,
            silentCheckSsoFallback: false
        });
    }

    return await keycloakInitPromise;
}
